import { createContext, useEffect, useState } from "react";
import { UserProfile, UserProfileToken } from "../Models/User";
import { useNavigate } from "react-router-dom";
import { loginAPI, registerAPI } from "../Services/AuthService";
import { toast } from "react-toastify";
import React from "react";
import axios from "axios";
import { profile } from "console";

type UserContextType = {
  user: UserProfile | null;
  token: string | null;
  registerUser: (email: string, username: string, password: string) => void;
  loginUser: (username: string, password: string) => void;
  logout: () => void;
  isLoggedIn: () => boolean;
  updateUser: (userProfile: UserProfileToken) => void;
};

type Props = { children: React.ReactNode };

const UserContext = createContext<UserContextType>({} as UserContextType);

export const UserProvider = ({ children }: Props) => {
  const navigate = useNavigate();
  const [token, setToken] = useState<string | null>(null);
  const [user, setUser] = useState<UserProfile | null>(null);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const user = localStorage.getItem("user");
    const token = localStorage.getItem("token");
    if (user && token) {
      setUser(JSON.parse(user));
      setToken(token);
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    }
    setIsReady(true);
  }, []);

  const registerUser = async (
    email: string,
    username: string,
    password: string
  ) => {
    await registerAPI(email, username, password)
      .then((res) => {
        if (res) {
          localStorage.setItem("token", res?.data.token);
          const userObj = {
            id: res?.data.id,
            username: res?.data.username,
            email: res?.data.email,
            first_name: res?.data.first_name,
            last_name: res?.data.last_name,
            rider_type: res?.data.rider_type,
            location: res?.data.location,
            profile_pic_url: res?.data.profile_pic_url
          };
          localStorage.setItem("user", JSON.stringify(userObj));
          setToken(res?.data.token!);
          setUser(userObj!);
          toast.success("Login Success!");
          navigate("/");
        }
      })
      .catch((e) => toast.warning("Server error occured"));
  };

  const loginUser = async (email: string, password: string, redirect: string = "/") => {
    await loginAPI(email, password)
      .then((res) => {
        if (res?.data) {
          localStorage.setItem("token", res?.data.token);
          const userObj = {
            id: res?.data.id,
            username: res?.data.username,
            email: res?.data.email,
            first_name: res?.data.first_name,
            last_name: res?.data.last_name,
            rider_type: res?.data.rider_type,
            location: res?.data.location,
            profile_pic_url: res?.data.profile_pic_url
          };
          localStorage.setItem("user", JSON.stringify(userObj));
          setToken(res?.data.token!);
          setUser(userObj!);
          toast.success("Login Success!");
          navigate(redirect);
        }
      })
      .catch((e) => toast.warning("Server error occured"));
  };

  const isLoggedIn = () => {
    return !!user;
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setUser(null);
    setToken("");
    navigate("/");
  };

  const updateUser = async (UserProfile: UserProfileToken) => {
          const userObj = {
            id: UserProfile?.id,
            username: UserProfile.username,
            email: UserProfile.email,
            first_name: UserProfile.first_name,
            last_name: UserProfile.last_name,
            rider_type: UserProfile.rider_type,
            location: UserProfile.location,
            profile_pic_url: UserProfile.profile_pic_url
          };
          localStorage.setItem("user", JSON.stringify(userObj));
          setUser(userObj!);
          toast.success("Profile updated successfully!");
          navigate("/userProfile");
    };

  return (
    <UserContext.Provider
      value={{ loginUser, user, token, logout, isLoggedIn, registerUser, updateUser }}
    >
      {isReady ? children : null}
    </UserContext.Provider>
  );
};

export const useAuth = () => React.useContext(UserContext);
